import React, { useState, useEffect } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router";
import WheelTypeService from "src/service/wheel";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Update Wheel No",
  },
];

const validationSchema = yup.object({
  wheel_type: yup
    .string("Enter wheel type")
    .min(1, "wheel type  should be of minimum 1 characters in length")
    .max(30, "wheel type  should be of maximum 30 characters in length")
    .required("wheel type is required"),
});

const UpdateWheelType = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const param = useParams();

  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    id: param.id,
    wheel_type: "",
    c_by: sessionData.data.id,
  });

  useEffect(() => {
    const fetchWheelTypeData = async () => {
      try {
        const res = await WheelTypeService.getWheelType({
          id: param.id,
        });

        // Update the initialValues once data is fetched
        setInitialValues({
          id: param.id,
          wheel_type: res.data[0].wheel_type,
          d_by: sessionData.data.id,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchWheelTypeData();
  }, [param.id, sessionData.data.id, sessionData.data.user_type]);

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));

        try {
          const res = await WheelTypeService.updateWheelType(values);
          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/wheelType");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  // =============================

  return (
    <div>
      <Breadcrumb title="Update Wheel No" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Update Wheel No
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/wheelType");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {/*   ==== manufacturer name  -===  */}
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "10px" }}
            >
              <CustomFormLabel htmlFor="wheel_type">
                No of Wheel
              </CustomFormLabel>
              <CustomTextField
                id="wheel_type"
                name="wheel_type"
                type="text"
                value={values.wheel_type}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.wheel_type && Boolean(errors.wheel_type)}
                helperText={touched.wheel_type && errors.wheel_type}
                variant="outlined"
                placeholder="Enter wheel type"
                fullWidth
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button color="success" variant="contained" type="submit">
                Update
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default UpdateWheelType;
